import React from 'react';
import { Box, Fab, Fade, useScrollTrigger } from '@mui/material';
import ArrowUpwardRoundedIcon from '@mui/icons-material/ArrowUpwardRounded';

const ScrollToTop: React.FC<{ isLeftAlign?: boolean }> = ({ isLeftAlign }) => {
  const onClickHandler = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };

  const trigger = useScrollTrigger({ threshold: 1000 });

  return (
    <>
      <Fade in={trigger}>
        <Box
          sx={{
            position: 'fixed',
            bottom: { xs: '5rem', sm: '4rem', md: '4rem' },
            left: isLeftAlign
              ? { xs: '1rem', sm: '4rem', md: '4rem' }
              : 'unset',
            right: isLeftAlign
              ? 'unset'
              : { xs: '6rem', sm: '8rem', md: '8rem' },
            zIndex: '2000',
          }}
        >
          <Fab color="primary" onClick={onClickHandler}>
            <ArrowUpwardRoundedIcon />
          </Fab>
        </Box>
      </Fade>
    </>
  );
};

export default ScrollToTop;
